import React, { FC } from 'react';
import { Brand } from '@clearcover/atlas';
import headset from 'Shared/assets/images/headset.png';
import styles from './styles.module.css';
import { QuoteNumber } from 'QuoteApp/components';

type ClearcoverSupportPropsType = {
  testId?: string;
  title: string;
};

export const ClearcoverSupport: FC<ClearcoverSupportPropsType> = ({
  testId,
  title,
  children,
}) => {
  return (
    <div className={styles.container} data-testid={testId}>
      <div className={styles.header}>
        <Brand className={styles.logo} />
        <QuoteNumber />
      </div>
      <div className={styles.body}>
        <img src={headset} alt="Clearcover Support" className={styles.image} />
        <h1 className={styles.heading}>{title}</h1>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};
